import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { CCard, CCardBody, CCol, CRow, CProgress, CFormLabel, CFormTextarea, CButton, CImage } from 'compat/coreui'
import axios from 'axios';
import Rating from 'react-rating';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';


export default function ReviewSection({ seller }) {
    const [review, setReview] = useState('');
    const [rating, setRating] = useState(0);
    const [value, setValue] = useState(0);
    const [voteCount, setVoteCount] = useState(0);
    const [show, setShow] = useState(false);
    const token = localStorage.getItem('token');
    const user = useSelector(state => state.user);

    const reviewHandler = (e) => {

        e.preventDefault();
        axios({
            url: `${process.env.REACT_APP_APP_API_URL}/api/review`,
            headers: {
                Authorization: `Bearer ${token}`
            },
            method: `POST`,
            data: {
                reviewed: seller._id,
                reviewer: user._id,
                msg: review,
                type: 2,
                rating: value,
            }
        }).then(response => {
            console.log('review api response', response);
            if (response.data.status) {
                toast.success('Reviewed successfully');
                setReview("");
                setValue(0);
            } else {
                toast.error(response.message)
            }
        }).catch(console.log)
    }


    return (
        <div>
            <CCard className="business-dashboard-new">
                <CCardBody>
                    <CRow className="p-4">
                        <CCol xl={4}>
                            <div>
                                <div className="hexagon"><span>{seller.reviews && seller.reviews.length} Reviews</span></div>
                            </div>
                        </CCol>
                        <CCol xl={4}>
                            <CFormLabel className="progress-label">Med Quality</CFormLabel>
                            <CProgress
                                color="success"
                                value={0}
                                showValue
                                className="mb-3"
                                size="lg"
                            />
                            <CFormLabel className="progress-label">Bud Drivers</CFormLabel>
                            <CProgress
                                color="success"
                                value={0}
                                showValue
                                className="mb-3"
                            />
                            <CFormLabel className="progress-label">Knowledge</CFormLabel>
                            <CProgress
                                color="success"
                                value={0}
                                showValue
                                className="mb-3"
                            />
                        </CCol>
                        <CCol xl={4}>
                            <CFormLabel className="progress-label">Price</CFormLabel>
                            <CProgress
                                color="success"
                                value={0}
                                showValue
                                className="mb-3"
                            />
                            <CFormLabel className="progress-label">Speediness</CFormLabel>
                            <CProgress
                                color="success"
                                value={0}
                                showValue
                                className="mb-3"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol xl={12} className="comment-section">
                            <div>
                                <CFormLabel className="comment-label">Leave a review or a tip...</CFormLabel>
                                <CFormTextarea
                                    type="textarea"
                                    placeholder="How would you describe your experience here?"
                                    name="review"
                                    onChange={(e) => setReview(e.target.value)}
                                    onFocus={(e) => setShow(!show)}
                                />
                                {show &&
                                    <div className="review-stars">
                                        <CCol lg={6}>
                                            <CFormLabel className="progress-label">Rate</CFormLabel>
                                            <Rating
                                                emptySymbol="fa fa-star-o fa-2x"
                                                fullSymbol="fa fa-star fa-2x"
                                                style={{ color: '#f9c739' }}
                                                initialRating={value}
                                                onClick={(value) => setValue(value)}
                                            />
                                        </CCol>
                                    </div>
                                }
                                <CCol xl={5} className="m-auto">
                                    <CButton color="success" className="mt-3 pl-4 pr-4" onClick={reviewHandler}>Submit Review</CButton>
                                </CCol>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg={12} className="review-headding"><h2>Reviews & Tips</h2></CCol>
                        <CCol xl={12}>
                            <table className="review-table">
                                <tbody>
                                    {(seller && seller.reviews) && seller.reviews.map((reviewItem, i) => {
                                        const postTime = moment(reviewItem.createdAt, 'YYYY-M-DD').format('DD-MM-YY');
                                        return (<tr key={i}>
                                            <td>
                                                <span className="upvote">
                                                    <i className="fa fa-angle-up"></i>
                                                    <span>{voteCount}</span>
                                                    <i className="fa fa-angle-down"></i>
                                                </span>
                                            </td>
                                            <td><CImage width="77%" src="/images/smoke1.png" className="rounded-circle" /></td>
                                            <td>
                                                <div>
                                                    <p>{reviewItem.msg}</p>
                                                    <span className="feature-text">Featured</span>
                                                    <span>{Array.apply(null, { length: reviewItem.rating }).map((i, index) => <CImage width="30" src="/images/11.png" key={index} />)}</span>
                                                    <span>Posted on {postTime}</span><span>venus</span>
                                                </div>
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </div>
    )
}